import { IRights, Right } from "constants/right";
import { Scope } from "helpers/authenticate";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ICurrentUser } from "interfaces/entities/current-user";
import { SessionAction, SessionActionNames } from "store/features/session/actions";

export interface ISessionState {
  user?: ICurrentUser;
  rights?: IRights;
  isGhostLogin: boolean;
  transientFlags?: Record<string, boolean>;
}

const initialState = {
  user: {
    id: null,
    accessToken: null,
    scopes: [],
    properties: null,
  },
  isGhostLogin: false,
  transientFlags: {},
  rights: null,
};

function mapScopesToRights(scopes: Scope[]): IRights {
  const isOwner = scopes.includes(Scope.AccountsAllRw);
  const isViewer = !isOwner && !scopes.includes(Scope.AccountsMyRw);

  return {
    // agents
    [Right.ManageAgents]: isOwner,
    [Right.ManageTeams]: isOwner,
    [Right.SeeOtherAgentsTeams]: isOwner,
    [Right.ImportLiveChatAgents]: isOwner,
    [Right.ManageOwnSignature]: !isViewer,

    // tickets
    [Right.CreateTickets]: !isViewer,
    [Right.ManageTickets]: !isViewer,
    [Right.DeleteTickets]: isOwner,
    [Right.CreateCustomViews]: !isViewer,
    [Right.SeeCustomViews]: !isViewer,

    // settings
    [Right.SeeSettings]: !isViewer,
    [Right.ManageCompanyName]: isOwner,
    [Right.ManageSharedCannedResponses]: isOwner,
    [Right.ManageSharedTags]: isOwner,
    [Right.ManageNotifications]: isOwner,
    [Right.ManageCustomMailboxes]: isOwner,
    [Right.ImportDataFromLiveChat]: isOwner,

    // subscription
    [Right.ManageSubscription]: isOwner,

    // reports
    [Right.SeeReports]: !isViewer,
    [Right.ExportReports]: !isViewer,
  };
}

// @ts-expect-error TS(2322): Type '{ user: { id: null; accessToken: null; scope... Remove this comment to see the full error message
const sessionReducer = (state: ISessionState = initialState, action?: SessionAction): ISessionState => {
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  switch (action.type) {
    case SessionActionNames.SAVE_ACCESS_TOKEN: {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const { accessToken } = action.payload;

      return {
        ...state,
        // @ts-expect-error TS(2322): Type '{ accessToken: any; id?: string | undefined;... Remove this comment to see the full error message
        user: {
          ...state.user,
          accessToken,
        },
      };
    }

    case SessionActionNames.SAVE_SCOPES: {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const { scopes } = action.payload;

      return {
        ...state,
        // @ts-expect-error TS(2322): Type '{ scopes: any; id?: string | undefined; acce... Remove this comment to see the full error message
        user: {
          ...state.user,
          scopes,
        },
        rights: mapScopesToRights(scopes),
      };
    }

    case SessionActionNames.SAVE_CURRENT_AGENT: {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const { id, isGhostLogin, properties } = action.payload;
      return {
        ...state,
        isGhostLogin,
        // @ts-expect-error TS(2322): Type '{ id: any; properties: any; scopes?: Scope[]... Remove this comment to see the full error message
        user: {
          ...state.user,
          id,
          properties,
        },
      };
    }

    case SessionActionNames.SET_TRANSIENT_FLAG: {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const { name, value } = action.payload;

      return {
        ...state,
        transientFlags: {
          ...(state.transientFlags || {}),
          [name]: value,
        },
      };
    }

    default:
      return state;
  }
};

export default sessionReducer;
